import React from 'react';
import './PMResourcesDocumentComponent.css';

const PmResourcesDocumentComponent = ({pmResources}) => {
    return (
        <div>
            <div className="procation">
                <h2 className="section-title">Project Management Resources</h2>
                <div className="container">
                    <div className="col-sm-12">
                        <div className="row">
                            {pmResources.map((pro, index) => (
                                <div className="col-sm-6 project-item-card" key={index}>
                                    <div>
                                        <div className="project-item-image-div">
                                            <h3 className="item-title">
                                                <b><a href={pro.url} target="_blank" rel="noreferrer">
                                                    {pro.title}
                                                </a></b>
                                            </h3>
                                            <div className="item-image-div">
                                                <a href={pro.url} target="_blank" rel="noreferrer">
                                                    <div className="custom-card-image-div" alt={pro.title}
                                                         style={{backgroundImage: `url("${pro.img}")`}}>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="project-item-card-content">
                                            <ul className="item-description">
                                                {pro.description.map((des, index) => (
                                                    <li key={index}>{des}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PmResourcesDocumentComponent;
